export const keywordPlannerActions = {
  LIST: 'LIST',
  ADD_KEYWORD: 'ADD_KEYWORD',
  ADD_NEGATIVE: 'ADD_NEGATIVE',
};
